<script setup> 
  import { computed } from 'vue';
  import CurrentConditionsDataList from "@/components/CurrentConditionsDataList.vue";
  import CurrentConditionsDataSource from "@/components/CurrentConditionsDataSource.vue";

  const emit = defineEmits(['data-item:click']);

  const props = defineProps({
    upgrade: {
      type: Array,
      required: true
    },
    allowedDataValues: {
      type: Array,
      default: () => []
    },
    tagList: {
      type: Boolean,
      default: false
    },
    hideSource: {
      type: Boolean,
      default: false
    },
    useButtons: {
      type: Boolean,
      default: false
    },
    spotDataObject: {
      type: Object,
      required: true
    }
  });

  const dataItemClickEvent = computed(() => {
    if (!props.useButtons) return {};

    return { 'data-item:click': handleDataListItemClick };
  });

  function handleDataListItemClick(event) {
    emit('data-item:click', event);
  }
</script>

<template>
  <CurrentConditionsDataList
    :upgrade="props.upgrade"      
    :tagList="props.tagList"
    :allowedDataValues="props.allowedDataValues"
    :useButton="props.useButtons"
    :spotDataObject="props.spotDataObject"
    v-on="dataItemClickEvent"
  />
  <CurrentConditionsDataSource v-if="!props.hideSource" :spotDataObject="props.spotDataObject" />
</template>